module.exports = __webpack_public_path__ + "img/violet_072.d28688f3.png";